module.exports = __webpack_public_path__ + "img/Coin@3x.696ace8c.png";